import React from "react";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";
import MembersApi from "../../../services/portal-api/MembersApi";
import TextInput from "../../../components/Form/components/TextInput";
import AuthService from "../../../services/AuthService";
import swal from "sweetalert";
import LoadingSpinner from "../../../components/LoadingSpinner";
import moment from "moment";
import { GridLoader } from "react-spinners";
import BlankCardsList from "./components/BlankCardsList";
import RestartQueue from "./components/RestartQueue";

export default class OverrideSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                STORE_ADMIN_TIMEOUT: 0,
                SUPER_ADMIN_TIMEOUT: 0,
                STORE_USER_TIMEOUT: 0,
                CUST_ADMIN_TIMEOUT: 0,
                AREA_MANAGER_TIMEOUT: 0,
            },
            errors: {},
            isLoading: false,
            futuraNo: "",
            messages: [],
            jobId: "",
            cards: [],
            totalCards: 0,
            currentPage: 1,
            queueInProgress: false,
            syncStatus: true,
            digitalCardStockLevel: 0,
            activateOrange: false
        };
    }

    componentDidMount() {
        this._loadSettings();
        this.getLastCard();
        this._loadStockLevel();
    }

    componentDidUpdate() {
        if(localStorage.getItem("queueJobDetails")) {
            setTimeout(() => {
                this.checkQueueInProgressInstance = this.checkQueueInProgress.bind(this);
                this.checkQueueInProgressInstance();
            }, 5000);
        }
    }

    _loadStockLevel = () => {  
        this.getStockLevelCallId = MembersApi.getStockLevel((result, callId) => {
            if (callId !== this.getStockLevelCallId) {
                return;
            }

            this.setState({
                digitalCardStockLevel: result.json.stockLevel
            });
        });
    };

    getLastCard = () => {
        let newElement = '';
        this.getLastSyncDetails().then((queueJobDetails) => {
            let completedAt = queueJobDetails.completedAt != '' ? this.convertUTCToLocalTime(queueJobDetails.completedAt) : '';
            const jobId = queueJobDetails.queueJobId;
            const cardBeforeSync = queueJobDetails.cardBeforeSync;
            const cardAfterSync = queueJobDetails.cardAfterSync;
            if (queueJobDetails.jobStatus == 'Failed') {
                completedAt = `${this.convertUTCToLocalTime(queueJobDetails.completedAt)} (Sync Failed – ${queueJobDetails.note})`
            }
            if (queueJobDetails.jobStatus == 'Success' && (cardBeforeSync == cardAfterSync)) {
                completedAt = `${this.convertUTCToLocalTime(queueJobDetails.completedAt)} (Sync Success – ${queueJobDetails.note})`
            }

            newElement = `<b>Last sync:</b> ${completedAt} <br> 
                          <b>Queue job id:</b> ${jobId} <br>`;
            if (queueJobDetails.jobStatus == 'Success' && (cardBeforeSync != cardAfterSync)) {
                newElement += `<b>Cards before sync:</b> ${cardBeforeSync} <br> 
                               <b>Cards after sync:</b> ${cardAfterSync} <br> `;
            } 
            if (queueJobDetails.jobStatus == 'Success' && (cardBeforeSync == cardAfterSync)) {
                newElement += `<b>Cards after sync:</b> ${cardAfterSync} <br> `;
            }

            this.setState({
                messages: newElement,
                syncStatus: (queueJobDetails.jobStatus == 'Success' || queueJobDetails.jobStatus == '') ? true : false
            }, () => {
                console.log('sync status', this.state.syncStatus, 'queueJobDetails.jobStatus', queueJobDetails.jobStatus);
                this._loadStockLevel();
            });

        }).catch((err) => {
            console.error(err);
        });
    };

    getLastSyncDetails() {
        return new Promise(function (resolve, reject) {
            MembersApi.getLastSyncDetails(function (response) {
                const { success, json } = response;
                if (success) {
                    resolve(json);
                } else {
                    reject(new Error("Failed to get last sync details"));
                }
            });
        });
    }

    checkQueue = () => {
        this.getLastSyncDetails()
            .then((queueJob) => {
                const queueJobDetails = JSON.parse(localStorage.getItem("queueJobDetails"));
                console.log(queueJobDetails.queueJobId);
                if (queueJobDetails && queueJobDetails.queueJobId === queueJob.queueJobId) {
                    console.log("if Queue");
                    this.setState({
                        messages: `<b>Sync in progress ...</b>`,
                        queueInProgress: true,
                        activateOrange: true
                    });
                    setTimeout(() => this.checkQueue(), 60000);
                } else {
                    console.log("else Queue");
                    const newElement = `<b>Last sync:</b> ${this.convertUTCToLocalTime(queueJob.completedAt)} <br>
                                        <b>Queue job id:</b> ${queueJob.queueJobId} <br> 
                                        <b>Cards before sync:</b> ${queueJob.cardBeforeSync} <br>
                                        <b>Cards after sync:</b> ${queueJob.cardAfterSync}`;
                    this.setState({
                        messages: newElement,
                        queueInProgress: false,
                        activateOrange: false,
                        isLoading: false,
                        syncStatus: true
                    }, () => {
                        localStorage.removeItem("queueJobDetails");
                        console.log("Queue finished successfully");
                        this._loadStockLevel();
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };
   
    checkQueueInProgress = () => {
        this.checkQueue();
    };

    serverSideEvents = () => {
        const eventSource = new EventSource("/index.php/api/test/sse");
        eventSource.onmessage = (event) => {
            const data = JSON.parse(event.data);

            if (data.futuraNo) {
                const newElement =
                    "Last card added on " +
                    this.convertUTCToLocalTime(data.dateTime) +
                    " - Card No.: " +
                    data.cardNo +
                    ", Futura No.: " +
                    data.futuraNo;
                if (data.futuraNo !== this.state.futuraNo) {
                    this.setState((prevState) => ({
                        futuraNo: data.futuraNo,
                        messages: [...prevState.messages, newElement],
                    }));
                }
            }
        };
    };

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        );
        const localTime = new Date(milliseconds);

        let cd =
            localTime.getFullYear() +
            "-" +
            (localTime.getMonth() + 1) +
            "-" +
            localTime.getDate() +
            " " +
            localTime.getHours() +
            ":" +
            localTime.getMinutes() +
            ":" +
            localTime.getSeconds();
        return moment(cd).format("DD/MM/YYYY h:mm A");
    };

    _loadSettings = () => {
        MembersApi.getSettingsAll((response) => {
            if (response.success) {
                const { data } = this.state;
                response.json.settings.forEach((v, k) => {
                    data[v.setting_keys] =
                        v.setting_keys != undefined || v.setting_keys != ""
                            ? v.setting_values
                            : 0;
                });
                this.setState(
                    {
                        data: data,
                    },
                    () => {
                        console.log("setto", this.state.data);
                    }
                );
            } else {
                this.props.sessionLoadOut(response);
            }
        });
    };

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;

        if (
            name == "STORE_USER_TIMEOUT" ||
            name == "STORE_ADMIN_TIMEOUT" ||
            name == "SUPER_ADMIN_TIMEOUT" ||
            name == "CUST_ADMIN_TIMEOUT" ||
            name == "AREA_MANAGER_TIMEOUT"
        ) {
            data[name] = event.target.value == "" ? 0 : event.target.value;
        } else {
            data[name] =
                event.target.type === "checkbox"
                    ? event.target.checked
                    : event.target.value;
        }

        this.setState({
            data: data,
            errors: errors,
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });

        MembersApi.settingsSave(this.state.data, (response) => {
            if (response.success) {
                this.setState(
                    {
                        isLoading: false,
                        viewSlug: response.json.message,
                    },
                    () => {
                        this._loadSettings();
                    }
                );
            } else {
                if (response.status === 401) {
                    this.props.sessionExpired(response);
                    this.setState({
                        isLoading: false,
                        viewSlug: null,
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.errors },
                        viewSlug: null,
                    });
                }
            }
        });
    };

    syncDigitalCards = () => {
        this.getLastSyncDetails()
            .then((queueJobDetails) => {
                if (queueJobDetails) {
                    this.setState({
                        isLoading: true,
                    }, () => {
                        MembersApi.settingsSyncDigitalCard((response) => {
                            if (response.json && response.json.success) {
                                if (response.json.sync) {
                                    localStorage.setItem("queueJobDetails", JSON.stringify(queueJobDetails));
                                    console.log("Stored queueJobId in localStorage:", JSON.parse(localStorage.getItem("queueJobDetails")));
                                    const messages = `<b>Sync in process... You can safely navigate to other pages.<b>`;
                                    this.setState({
                                            messages: messages,    
                                            activateOrange: true
                                    }, () => {
                                        swal("Sync initiated", {
                                            icon: "success",
                                            buttons: false,
                                            timer: 3000,
                                        });
                                        
                                    });
                                } else {
                                    this.setState({ 
                                        isLoading: false,
                                        activateOrange: false
                                    });
                                    localStorage.removeItem("queueJobDetails");
                                    swal("Nothing to sync. Local table is up to date.", {
                                            icon: "warning",
                                            buttons: false,
                                            timer: 3000,
                                    });

                                    this.getLastCard();
                                }
                            } else {
                                this.setState({ 
                                    isLoading: false,
                                    activateOrange: false,
                                });
                                swal(response.json.message, {
                                    icon: "error",
                                    buttons: false,
                                    timer: 3000,
                                });
                                this.getLastCard();
                            }
                        });
                    });
                } else {
                    console.error("Queue Job ID is null or undefined.");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    render() {
        const { messages, digitalCardStockLevel, syncStatus, activateOrange } = this.state;
        let c = "";
        if (this.state.viewSlug) {
            c = (
                <div className="alert alert--success alert--outline text--center margin--40--bot">
                    {this.state.viewSlug}
                </div>
            );
        }
        const errorsmsg = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            errorsmsg.push(
                <div
                    key={key}
                    className="alert alert--outline alert--error margin--40--bot"
                >
                    <span>
                        Sorry, unable to save the settings:{" "}
                        <strong>{value}</strong>
                    </span>
                </div>
            );
        }
        return (
            <div>
                <div className="col gutter--40">
                    <div className="col">
                        <div className="col">
                            <h2 className="text--light text--green text--40 margin--40--top margin--40--bot">
                                All Settings
                            </h2>
                        </div>
                    </div>
                    <div
                        className="col"
                        style={{ borderBottom: "1px solid #ccc" }}
                    >
                        {c} {errorsmsg}
                    </div>
                </div>
                <div
                    className="table--overflow clearfix"
                    style={{ overflow: "hidden" }}
                >
                    <p className="text--light text--green text--20 margin--20--top margin--20--bot">
                        Timeout Settings
                    </p>
                    <div className="col">
                        <form onSubmit={this.handleSubmit}>
                            <div className="col-2 gutter--40">
                                {AuthService.can("settings") && (
                                    <div className="col">
                                        <TextInput
                                            type="text"
                                            name="SUPER_ADMIN_TIMEOUT"
                                            label="Super Admin Timeout (Mins)"
                                            placeholder="Enter minutes .."
                                            value={
                                                this.state.data
                                                    .SUPER_ADMIN_TIMEOUT == 0
                                                    ? ""
                                                    : this.state.data
                                                          .SUPER_ADMIN_TIMEOUT
                                            }
                                            error={this.state.errors.timeoutp}
                                            onChange={this.handleInput}
                                            required={false}
                                        />
                                    </div>
                                )}
                                {AuthService.can("settings") && (
                                    <div className="col">
                                        <TextInput
                                            type="text"
                                            name="STORE_ADMIN_TIMEOUT"
                                            label="Store Admin Timeout (Mins)"
                                            placeholder="Enter minutes .."
                                            value={
                                                this.state.data
                                                    .STORE_ADMIN_TIMEOUT == 0
                                                    ? ""
                                                    : this.state.data
                                                          .STORE_ADMIN_TIMEOUT
                                            }
                                            error={this.state.errors.timeoutp}
                                            onChange={this.handleInput}
                                            required={false}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="col-2 gutter--40">
                                {AuthService.can("settings") && (
                                    <div className="col">
                                        <TextInput
                                            type="text"
                                            name="STORE_USER_TIMEOUT"
                                            label="Store User timeout (Mins)"
                                            placeholder="Enter minutes .."
                                            value={
                                                this.state.data
                                                    .STORE_USER_TIMEOUT == 0
                                                    ? ""
                                                    : this.state.data
                                                          .STORE_USER_TIMEOUT
                                            }
                                            error={this.state.errors.timeoutp}
                                            onChange={this.handleInput}
                                            required={false}
                                        />
                                    </div>
                                )}
                                {AuthService.can("settings") && (
                                    <div className="col">
                                        <TextInput
                                            type="text"
                                            name="CUST_ADMIN_TIMEOUT"
                                            label="Customer Admin timeout (Mins)"
                                            placeholder="Enter minutes .."
                                            value={
                                                this.state.data
                                                    .CUST_ADMIN_TIMEOUT == 0
                                                    ? ""
                                                    : this.state.data
                                                          .CUST_ADMIN_TIMEOUT
                                            }
                                            error={this.state.errors.timeoutp}
                                            onChange={this.handleInput}
                                            required={false}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="col-2 gutter--40">
                                {AuthService.can("settings") && (
                                    <div className="col">
                                        <TextInput
                                            type="text"
                                            name="CUST_ADMIN_TIMEOUT"
                                            label="Customer Admin timeout (Mins)"
                                            placeholder="Enter minutes .."
                                            value={
                                                this.state.data
                                                    .AREA_MANAGER_TIMEOUT == 0
                                                    ? ""
                                                    : this.state.data
                                                          .AREA_MANAGER_TIMEOUT
                                            }
                                            error={this.state.errors.timeoutp}
                                            onChange={this.handleInput}
                                            required={false}
                                        />
                                    </div>
                                )}
                            </div>

                            <footer className="footer--form clearfix">
                                <div className="footer--form__left"></div>
                                {AuthService.can("settings") && (
                                    <div className="footer--form__right">
                                        <button
                                            type="submit"
                                            className="btn btn--large btn--blue margin--30--top u-right"
                                        >
                                            Save
                                        </button>
                                    </div>
                                )}
                            </footer>
                            <div
                                className="col"
                                style={{
                                    borderBottom:
                                        "1px solid rgb(204, 204, 204)",
                                    marginTop: "10px",
                                }}
                            ></div>
                        </form>
                    </div>
                </div>

                <div
                    className="table--overflow clearfix"
                    style={{ overflow: "hidden" }}
                >
                    <p className="text--light text--green text--20 margin--20--top margin--20--bot">
                        Blank Digital Cards <br />
                        <span style={{ color: "grey", fontSize: 12 }}>Current Stock Level: {digitalCardStockLevel}</span>
                    </p>


                    <div
                        className="col"
                        style={{
                            backgroundColor: "#EFE8CF",
                            padding: "10px",
                            overflow: "hidden",
                            marginBottom: "10px",
                            border: "1px solid #ccc",
                        }}
                    >
                        <ul
                            id="list"
                            style={{
                                overflowY: "auto",
                                maxHeight: "300px",
                                color: syncStatus  === true ? (activateOrange ? "#E89714" : "#5E7F5E") : (activateOrange ? "#E89714" : "#ff3535"),
                                fontSize: "13px",
                                padding: "0",
                                margin: "0",
                                borderRadius: "5px",
                            }}
                        >
                           
                        <li style={{ marginBottom: "5px" }}><div dangerouslySetInnerHTML={{ __html: messages }}></div></li>
                           
                        </ul>
                    </div>
                    <div className="col">
                        <button
                            className="btn btn--small btn--open btn--blue"
                            onClick={this.syncDigitalCards}
                            data-id="ovrd"
                            disabled={this.state.isLoading}
                        >
                            {this.state.isLoading ? (
                                <GridLoader color="#ffffff" size={5} />
                            ) : (
                                "Sync Blank Digital Cards"
                            )}
                        </button>
                        <div className="col" style={{ marginTop: "10px" }}>
                            <p style={{ fontSize: "11px", marginTop: "10px" }}>
                                The synchronisation process will be a background
                                process. A success message will be immediately
                                received after clicking the sync button.
                            </p>
                        </div>
                    </div>
                </div>
                
                <div
                    className="table--overflow clearfix"
                    style={{
                        borderTop: "1px solid #ccc",
                        marginTop: "10px",
                    }}
                >
                    <p className="text--light text--green text--20 margin--20--top margin--20--bot" style={{
                        overflow: "hidden",
                        marginBottom: "10px",
                    }}>
                        Jobs Queue
                    </p>
                    <div className="col"  style={{ 
                        marginBottom: '10px', 
                        borderBottom: '1px solid #ccc' 
                    }}>
                        <RestartQueue />
                    </div>

                </div>
                
            </div>
        );
    }
}
